import { Menu, X } from 'lucide-react'
import Logo from '@/components/shared/Logo'

const MobileHeader = ({ isMenuOpen, setIsMenuOpen }) => {
  return (
    <div className="container mx-auto flex max-w-[90%] items-center justify-between py-1.5 lg:hidden">
      <div className="flex items-center">
        <Logo />
      </div>
      <div className="flex items-center">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="rounded-md p-2 transition-colors hover:bg-gray-100"
          aria-label="Toggle mobile menu"
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>
    </div>
  )
}

export default MobileHeader
